<template>
	<div class="cooperate-container">
		<div class="box">
			<div class="mainCont">
				<h2>加盟合作</h2>
				<div class="dec" v-html="articeObj.content"></div>
			</div>
		</div>
		<div class="box2 mainCont">
			<h2>留下您的信息</h2>
			<el-form :model="form" id="form" :rules="rules" ref="ruleForm" class="formBox">
				<el-form-item class="form_item w48" prop="company">
					<p class="laben">公司名称 <span>*</span></p>
					<div class="item_input">
						<el-input v-model="form.company" placeholder="输入公司"></el-input>
					</div>
				</el-form-item>
				<el-form-item class="form_item w48" prop="fzrName">
					<p class="laben">负责人 <span>*</span></p>
					<div class="item_input">
						<el-input v-model="form.fzrName" placeholder="输入负责人姓名"></el-input>
					</div>
				</el-form-item>
				<el-form-item class="form_item w48" prop="lxrMobile">
					<p class="laben">电话 <span>*</span></p>
					<div class="item_input">
						<el-input v-model="form.lxrMobile" type="number" :maxlength="11" placeholder="输入电话"></el-input>
					</div>
				</el-form-item>
				<el-form-item class="form_item w48" prop="yyzzNumber">
					<p class="laben">营业执照税号 <span>*</span></p>
					<div class="item_input">
						<el-input v-model="form.yyzzNumber" placeholder="输入营业执照税号"></el-input>
					</div>
				</el-form-item>
				<el-form-item class="form_item" prop="hzContent">
					<p class="laben">合作内容<span>*</span></p>
					<div class="item_input">
						<el-input v-model="form.hzContent" type="textarea" :rows="4" resize="none" placeholder="输入合作内容"></el-input>
					</div>
				</el-form-item>
				<el-form-item class="form_item" prop="companyAddress">
					<p class="laben">公司地址 <span>*</span></p>
					<div class="item_input">
						<el-input v-model="form.companyAddress" placeholder="输入公司地址"></el-input>
					</div>
				</el-form-item>
			</el-form>
			<el-button type="primary" class="form_btn" @click="submitForm('ruleForm')">提交平台</el-button>
		</div>
		
	</div>
</template>
<script >
import {getArtice,saveHezuoJiameng} from '@/api/api'
export default {
	name: 'cooperate',
	data() {
		return {
			val:"",
			articeObj:{},//加盟合作
			form:{
				"company": "",//公司名称
				"companyAddress": "",//公司地址
				"fzrName": "",//负责人名称
				"hzContent": "",//合作内容
				"lxrMobile": "",//联系电话
				"yyzzNumber": "",//营业执照号码
			},
			rules: {
				company: [
					{ required: true, message: '请输入公司名称', trigger: 'blur' },
				],
				fzrName: [
					{ required: true, message: '请输入负责人姓名', trigger: 'blur' },
				],
				lxrMobile: [
					{ required: true, message: '请输入电话', trigger: 'blur' },
				],
				yyzzNumber: [
					{ required: true, message: '请输入营业执照税号', trigger: 'blur' },
				],
				hzContent: [
					{ required: true, message: '请输入合作内容', trigger: 'blur' },
				],
				companyAddress: [
					{ required: true, message: '请输入公司地址', trigger: 'blur' },
				],
			},
		};
	},
	mounted() {
		this.getArtice();
	},
	methods: {
		// 加盟合作
		getArtice(){
			getArtice({type:'4'}).then(res => {
				this.articeObj = res.data;
			})
		},
		submitForm(formName) {
			this.$refs[formName].validate((valid) => {
			if (valid) {
				saveHezuoJiameng(this.form).then(res => {
					if(res.flag){
						this.$message({
							message: res.msg,
							type: 'success'
						});
						this.form = {
							"company": "",//公司名称
							"companyAddress": "",//公司地址
							"fzrName": "",//负责人名称
							"hzContent": "",//合作内容
							"lxrMobile": "",//联系电话
							"yyzzNumber": "",//营业执照号码
						};
					}else{
						this.$message(res.msg);
					}
					
				})
			}
			});
		},
		goDetail(){
			this.$router.push({
			path: '/server/detail',
				query: {
					mallCode: 'M000989'
				}
			})
		},
	},
};
</script>
<style lang="scss">
.cooperate-container{background-color: #F5F8F9;padding-top:24px;
	.box{background: #FFFFFF;padding: 72px 0;
		h2{color: #1F263F;font-size: 36px;font-weight: bold;text-align: center;margin-bottom: 40px;}
		.dec{color: #1F263F;font-size: 16px;margin-bottom: 26px;line-height: 30px;
			p{color: #1F263F;font-size: 16px;margin-bottom: 24px;line-height: 30px;
				&:last-child{margin-bottom: 0;}
			}
		}
	}
	.box2{padding: 64px 0 54px;
		h2{color: #1F263F;font-size: 36px;font-weight: bold;text-align: center;margin-bottom: 28px;}
		.formBox{display: flex;align-items: center;flex-wrap: wrap;justify-content: space-between;
			.form_item{width: 100%;margin-bottom: 24px;
				&.w48{width: 48.86%;}
				.laben{color: #1F263F;font-size: 16px;margin-bottom: 10px;
					span{color: #FA5623;}
				}
				.item_input{position: relative;width: 100%;display: flex;align-items: center;
					/* ::v-deep{ */
						
						.el-select,.el-input,.el-textarea{width: 100%;border-radius: 10px;
							.el-input__inner{border-radius: 5px;min-height: 60px;line-height: 60px;border: 0;font-size: 16px;}
							.el-textarea__inner{border-radius: 5px;line-height:26px;border: 0;font-size: 16px;}
						}
					/* } */
				}
			}
		}
		.form_btn{width: 500px;
height: 60px;background: #2F78FF;border-radius: 5px;padding: 0;border: 0;color:#fff;font-size: 20px;margin: 24px auto 0;cursor: pointer;display: block;}
	}
}
</style>


// WEBPACK FOOTER //
// src/views/cooperate/index.vue